<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">

        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-row>
                <b-col class="p-a-0 m-t-5px">
                    <label for="">Cliente</label>
                    <multiselect v-model="clienteSelected"
                    :options-limit="300"
                    :limit="2"
                    :limit-text="limitText"
                    :options="optionsClientes"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="(Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social)"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    :searchable="true"
                    :loading="isLoadingTom"
                    @search-change="listaClientes"
                    ></multiselect>
                </b-col>
            </b-row>
            <b-row>
               <b-col class="p-a-0 m-t-5px">
                   <label for="">Unidade</label>
                    <multiselect v-model="unidadeSelected"
                    :options-limit="300"
                    :limit="2"
                    :limit-text="limitText"
                    :options="optionsUnidades"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="(Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social)"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    :searchable="true"
                    :loading="isLoadingTom2"
                    @search-change="listaUnidades"
                    ></multiselect>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label>Status</label>
                    <b-form-group>
                    <b-form-radio-group
                        v-model="form.status"
                        :options="this.$parent.optionsStatus"
                        name="status"
                        plain
                    ></b-form-radio-group>
                    </b-form-group>
                    <b-form-feedback v-text="form.errors.get('status')"  v-if="form.errors.has('status')"></b-form-feedback>    
                </b-col>
            </b-row>
        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      optionsClientes: [],
      optionsUnidades: [],
      clienteSelected: [],
      unidadeSelected: [],
      errors_array: [],
      isLoadingTom: false,
      isLoadingTom2: false,
      form: new Form({  pessoa_id: '',
                        unidade_id: '',
                        status: '',
                        cliuni_id: ''
                   }),
     helpForm: new Form({statusRecord: [], params: [], search: ''}),
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    clienteSelected(obj) {
        this.form.pessoa_id = obj.value;
    },
    unidadeSelected(obj) {
        this.form.unidade_id = obj.value;
    },
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.cliuni_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.errors_array = '';
      this.errors_array = [];
      this.form.reset();
      this.clienteSelected = [];
      this.unidadeSelected = [];
      this.tpFeriadoSelected = [];
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit (data)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.clienteSelected = [];
      this.unidadeSelected = [];
      this.form.status = data.status.valor;
      this.clienteSelected = {label: data.pessoa.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(data.pessoa.pessoa_juridica.cnpj_base,data.pessoa.pessoa_juridica.cnpj_filial,data.pessoa.pessoa_juridica.cnpj_digito), value:data.pessoa.pessoa_juridica.pessoa_id};
      this.unidadeSelected = {label: data.unidade.pessoa.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(data.unidade.pessoa.pessoa_juridica.cnpj_base,data.unidade.pessoa.pessoa_juridica.cnpj_filial,data.unidade.pessoa.pessoa_juridica.cnpj_digito), value:data.unidade.unidade_id};
      this.form.cliuni_id = data.cliuni_id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/clienteunidade/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/clienteunidade/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/clienteunidade/status').then(response =>
        {
            new ReturnApi(response, this)

            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    listaClientes(search) {
        if(search.length>=3)
        {
            this.isLoadingTom = true;
            this.helpForm.search = search;
            this.helpForm.status = 1;
            this.helpForm.post('/api/pessoa/jsonlist').then(response =>
            {
                this.optionsClientes = [];
                new ReturnApi(response, this, true, false, false);
                response.items.forEach((obj)=>
                {
                    this.optionsClientes.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                });
                this.isLoadingTom = false;
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
                });
            }
        },
        listaUnidades(search) {
            if(search.length>=3)
            {
                // this.isLoadingTom2 = true;
                this.helpForm.search = search;
                this.helpForm.status = 1;
                this.helpForm.post('/api/unidade/jsonlist').then(response =>
                {
                    this.optionsUnidades = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsUnidades.push({ label: obj.cd+" - "+obj.pessoa.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(obj.pessoa.pessoa_juridica.cnpj_base,obj.pessoa.pessoa_juridica.cnpj_filial,obj.pessoa.pessoa_juridica.cnpj_digito)+" - "+obj.pessoa.pessoa_juridica.inscricao_estadual, value: obj.unidade_id })
                    });
                    // this.isLoadingTom2 = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                  });
              }
          },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
            var cnpj_formatado
            var pad = "00000000";
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
            return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
        },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
